import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getOnboardingState } from '../../../store/selectors';
import { fireGTM } from '../../../gtm/gtmUtil';
import { degreePairingPage_GTM } from '../../../gtm/datalayers/degreePairingDataLayers.json';

function CloseOutPathButton(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const buttonColoring = {
    background: `${props.tenant.primary}`,
  };

  const handleCloseOutPathSelected = (closeoutSelectedProps) => {
    degreePairingPage_GTM.closeOutPath.section =
      closeoutSelectedProps.onboarding.careerChoices[
        closeoutSelectedProps.onboarding.currentTab
      ].titleEn;
    fireGTM(degreePairingPage_GTM.closeOutPath);
    dispatch({
      type: 'SET_CAREER_TAB',
      payload: {
        careerInfo: {
          ...closeoutSelectedProps.onboarding.degreeChoices,
        },
        careerTabSelected: false,
        currentTab: 0,
      },
    });
  };

  return (
    <div className="closeout-button-container">
      <button
        className={`button--primary ${props.overRideStyle}`}
        onClick={() => handleCloseOutPathSelected(props)}
        onKeyDown={(e) => {
          if (['Enter'].includes(e.key)) handleCloseOutPathSelected(props);
        }}
        type="button"
        style={buttonColoring}
        data-cy="closeout-button"
        aria-label={`Close out your path below for ${props.careerName}`}
      >
        {`X ${t('Close out your path')}`}
      </button>
    </div>
  );
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);

  return { onboarding };
};

export default connect(mapStateToProps)(CloseOutPathButton);
